document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = window.location.href;
  const links = document.querySelectorAll(".site-nav__item a");
    links.forEach(link => {
    if (link.href === currentUrl) {
      link.classList.add("active");
    }
  });
    
const process_number_elements = document.querySelectorAll('#process-numbers li');
const hoverClass = 'active';

process_number_elements.forEach((process_number_element) => {
    process_number_element.addEventListener('mouseenter', () => {
        const dataAttr = process_number_element.getAttribute('data-process-item');
        const matchingElement = document.querySelector('.process-section-wrapper .process-content li[data-process-item="' + dataAttr + '"]');
        if (matchingElement) {
            matchingElement.classList.add(hoverClass);
        }
    });

    process_number_element.addEventListener('mouseleave', () => {
        const dataAttr = process_number_element.getAttribute('data-process-item');
        const matchingElement = document.querySelector('.process-section-wrapper .process-content li[data-process-item="' + dataAttr + '"]');
        if (matchingElement) {
            matchingElement.classList.remove(hoverClass);
        }
    });
});
              
              
const video = document.getElementById("split-section-video");
const playButton = document.getElementById("split-section-play-button");
if (video) {
playButton.addEventListener("click", function() {
    if (video.paused) {
        video.play();
        playButton.style.display = "none";
    } else {
        video.pause();
    }
});
}
});

